import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from "react-router-dom";
import App from './App.tsx'
import './index.css'
import './styles/day-picker.css'
import { Toaster } from "./components/ui/toaster"
import { Toaster as SonnerToaster } from 'sonner';
import { AuthProvider } from './providers/AuthProvider';
import { QueryProvider } from './providers/QueryProvider';
import { HelmetProvider } from 'react-helmet-async';
import { initErrorReporting } from './services/errorReporting';
import { initializeApiInterceptor } from './lib/apiInterceptor';
import ScrollToTop from './components/home/ScrollToTop';

// Remove any existing loading indicators
const existingLoader = document.getElementById('loading-indicator');
if (existingLoader) {
  existingLoader.remove();
}

// Initialize API interceptor first to prevent 401 flashes
// Must be initialized before any other code that might make API calls
initializeApiInterceptor();

// Initialize error reporting - disabled temporarily due to React conflicts
// initErrorReporting();

// Render the app
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <QueryProvider>
        <BrowserRouter>
          <ScrollToTop />
          <AuthProvider>
            <App />
            <Toaster />
            <SonnerToaster position="top-right" richColors />
          </AuthProvider>
        </BrowserRouter>
      </QueryProvider>
    </HelmetProvider>
  </React.StrictMode>,
);
